import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import useBasePage from 'app/shared/hooks/base-page.hook'
import { Button } from 'primereact/button'

/**
 * ======================================================================
 * @ 업무설명 : 로딩(접속 실패)
 * @ 파 일 명 : src\app\pages\auth\LoadFail.tsx
 * @ 화면  ID : SC-COM-2000-F2
 * ======================================================================
 * 번호  작업자           작업일         변경내용
 * ======================================================================
 * 1     김상돈(S24069)   2025.07.25     최초작성
 * ======================================================================
 */
const LoadFail: React.FC = () => {
    const { goHome } = useBasePage()
    return (
        <BasePage
            header={false}
            prev={false}
            className="pt-24"
            footerPosition="fixed"
            footerContent={
                <Button
                    label="홈으로 가기"
                    className="button-basic-primary -lg width-full"
                    onClick={() => {
                        goHome(true)
                    }}
                />
            }
        >
            <div className="common-result-fail">
                <p className="h4 bold">접속이 원활하지 않습니다</p>
                <p className="error-text mt-16">잠시 후 이용해주세요.</p>
            </div>
        </BasePage>
    )
}

export default LoadFail
